import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { EMPTY, Observable, catchError } from 'rxjs';
import { AuthService } from './shared/service/auth.service';

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const router = inject(Router);
  const authService = inject(AuthService)

  // console.log('HTTP Request:', req.url, req.method);

  return next(req).pipe(
    catchError((error: any) => {
      // console.log('HTTP Error:', error);
      if (error.status === 401) {
        if (router.url.includes("/article-details") || router.url.includes("/new-details")) {
          authService.addKey('RedirectedUrl', router.url);
        }
        localStorage.removeItem('isAdmin');
        localStorage.removeItem('isMember');
        localStorage.removeItem('token');
        localStorage.removeItem('userData');
        localStorage.removeItem('userId');
        localStorage.removeItem('userName');
        localStorage.removeItem('membershipModalClosed');
        router.navigate(['/login']);
        return EMPTY;
      }
      throw error;
    })
  );
};
